import '../../App.css';
import TripTracking from '../TripTracking';

function TrackingPage({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("trip-tracking")){
    return;}
  return (
    <div className="">
      <TripTracking sessionObject={sessionObject}/>
    </div>
  );
}

export default TrackingPage;